const Sort = ({ ...props }: any) => (
	<svg
		className="ml-1 inline-block"
		width="15"
		height="11"
		viewBox="0 0 15 11"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M0.0317383 1.19977C0.0317383 1.38977 0.094294 1.572 0.205644 1.70635C0.316993 1.8407 0.468016 1.91618 0.625488 1.91618H4.18799C4.34546 1.91618 4.49648 1.8407 4.60783 1.70635C4.71918 1.572 4.78174 1.38977 4.78174 1.19977C4.78174 1.00976 4.71918 0.827536 4.60783 0.693182C4.49648 0.558827 4.34546 0.483349 4.18799 0.483349H0.625488C0.468016 0.483349 0.316993 0.558827 0.205644 0.693182C0.094294 0.827536 0.0317383 1.00976 0.0317383 1.19977ZM0.0317383 5.49827C0.0317383 5.68827 0.094294 5.8705 0.205644 6.00485C0.316993 6.1392 0.468016 6.21468 0.625488 6.21468H8.93799C9.09546 6.21468 9.24648 6.1392 9.35783 6.00485C9.46918 5.8705 9.53174 5.68827 9.53174 5.49827C9.53174 5.30826 9.46918 5.12604 9.35783 4.99168C9.24648 4.85733 9.09546 4.78185 8.93799 4.78185H0.625488C0.468016 4.78185 0.316993 4.85733 0.205644 4.99168C0.094294 5.12604 0.0317383 5.30826 0.0317383 5.49827ZM0.0317383 9.79677C0.0317383 9.98677 0.094294 10.169 0.205644 10.3033C0.316993 10.4377 0.468016 10.5132 0.625488 10.5132H13.688C13.8455 10.5132 13.9965 10.4377 14.1078 10.3033C14.2192 10.169 14.2817 9.98677 14.2817 9.79677C14.2817 9.60676 14.2192 9.42454 14.1078 9.29018C13.9965 9.15583 13.8455 9.08035 13.688 9.08035H0.625488C0.468016 9.08035 0.316993 9.15583 0.205644 9.29018C0.094294 9.42454 0.0317383 9.60676 0.0317383 9.79677Z"
			fill="white"
		/>
	</svg>
);

export default Sort;
